import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';

import { User, Profile } from '@df/interfaces';
import { AccountService } from '@teacher/services/account.service';
import { HandlerService } from '@app/_services/handler.service';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

@Component({
    selector: 'app-email-profile-settings',
    templateUrl: './email-profile-settings.component.html',
    styleUrls: ['./email-profile-settings.component.scss']
})
export class EmailProfileSettingsComponent implements OnInit, OnDestroy {
    profile: Profile;
    emailForm: FormGroup;
    telephoneForm: FormGroup;
    user: User;
    isOldEmail = true;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private fb: FormBuilder,
        private handlerService: HandlerService,
        private accountService: AccountService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.route.data.subscribe(data => {
            this.profile = data['profile'].data;
        });

        this.emailForm = this.fb.group({
            email: [
                this.profile.user.email,
                [Validators.required, Validators.minLength(7), Validators.maxLength(35), Validators.email]
            ]
        });

        this.telephoneForm = this.fb.group({
            phone: [this.profile.phone, [Validators.required, Validators.pattern('[0-9 ]{11}')]]
        });
    }

    private updateProfile(): void {
        this.accountService.patchProfile(this.profile).subscribe(
            resp => {
                this.handlerService.checkErrors(resp);
                if (!resp.error) {
                    this.accountService.profile.next(resp.data);
                    const msg = 'Информация упешно обновлена';
                    this.handlerService.successMsg(msg);
                }
            },
            (error: HttpErrorResponse) => {
                this.handlerService.errorMsg(`${error.status} ... ${error.message}`);
                return throwError(error);
            }
        );
    }

    onSubmitEmail(): void {
        const { email } = this.emailForm.value;
        if (this.profile.user.email === email) {
            const msg = 'Для смены необходим другой email';
            this.handlerService.infoMsg(msg);
            return;
        }

        if (this.emailForm.valid) {
            this.profile.user.email = email;
            this.emailForm.patchValue({ email: email });

            this.accountService.changeEmail(this.profile).subscribe(resp => {
                if (resp.errors.length) {
                    resp.errors.forEach(item => {
                        const msg_duration = 4000;
                        console.error(item);
                        this.handlerService.errorMsg(item, msg_duration);
                    });
                    return;
                }

                if (resp.data && this.accountService.saveNewEmail(email)) {
                    const msg = `На почту ${email} была отправленна ссылка для потверждения`;
                    const msg_duration = 4000;
                    this.handlerService.successMsg(msg, msg_duration);
                }
            });
        }
    }

    onSubmitTelephone(): void {
        const { phone } = this.telephoneForm.value;
        if (this.profile.phone === phone) {
            const msg = 'Для смены необходим другой телефон';
            this.handlerService.infoMsg(msg);
            return;
        }

        if (this.telephoneForm.valid) {
            this.profile.phone = this.telephoneForm.value.phone;
            this.telephoneForm.patchValue({ phone: this.profile.phone });
            this.updateProfile();
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
